import type { ComponentConfig } from '@puckeditor/core'
import PaddingField, { type PaddingValue, defaultPadding, paddingToStyle } from './PaddingField'

export interface ImageBlockProps {
    src: string
    alt: string
    maxWidth: string
    borderRadius: number
    alignment: 'left' | 'center' | 'right'
    objectFit: 'cover' | 'contain' | 'fill'
    padding: PaddingValue
}

export const ImageBlock: ComponentConfig<ImageBlockProps> = {
    label: 'Image',
    defaultProps: {
        src: '',
        alt: '',
        maxWidth: '100%',
        borderRadius: 0,
        alignment: 'center',
        objectFit: 'cover',
        padding: defaultPadding,
    },
    fields: {
        src: {
            type: 'custom',
            label: 'Image',
            render: ({ value, onChange }) => (
                <div>
                    {value && (
                        <img
                            src={value}
                            alt="Preview"
                            style={{ width: '100%', maxHeight: 120, objectFit: 'contain', marginBottom: 8, borderRadius: 4 }}
                        />
                    )}
                    <input
                        type="text"
                        value={value}
                        onChange={e => onChange(e.target.value)}
                        placeholder="Enter image URL or use gallery"
                        style={{ width: '100%', padding: '6px 8px', border: '1px solid #d1d5db', borderRadius: 4, fontSize: 13, boxSizing: 'border-box' }}
                    />
                    <button
                        onClick={() => {
                            const event = new CustomEvent('puck-open-image-gallery', {
                                detail: { onChange },
                            })
                            window.dispatchEvent(event)
                        }}
                        style={{
                            marginTop: 6,
                            width: '100%',
                            padding: '6px 12px',
                            backgroundColor: '#4F46E5',
                            color: '#fff',
                            border: 'none',
                            borderRadius: 4,
                            cursor: 'pointer',
                            fontSize: 13,
                        }}
                    >
                        Choose from Gallery
                    </button>
                </div>
            ),
        },
        alt: { type: 'text', label: 'Alt Text' },
        maxWidth: { type: 'text', label: 'Max Width (e.g., 100%, 300px)' },
        borderRadius: { type: 'number', label: 'Border Radius', min: 0, max: 100 },
        alignment: {
            type: 'radio',
            label: 'Alignment',
            options: [
                { label: 'Left', value: 'left' },
                { label: 'Center', value: 'center' },
                { label: 'Right', value: 'right' },
            ],
        },
        objectFit: {
            type: 'select',
            label: 'Object Fit',
            options: [
                { label: 'Cover', value: 'cover' },
                { label: 'Contain', value: 'contain' },
                { label: 'Fill', value: 'fill' },
            ],
        },
        padding: {
            type: 'custom',
            render: ({ value, onChange }) => <PaddingField value={value} onChange={onChange} />,
        },
    },
    render: ({ src, alt, maxWidth, borderRadius, alignment, objectFit, padding }) => {
        if (!src) {
            return (
                <div style={{
                    textAlign: alignment,
                    padding: paddingToStyle(padding),
                    border: '2px dashed #d1d5db',
                    borderRadius: 8,
                    color: '#9ca3af',
                    fontSize: 14,
                }}>
                    No image selected
                </div>
            )
        }
        return (
            <div style={{ textAlign: alignment, padding: paddingToStyle(padding) }}>
                <img
                    src={src}
                    alt={alt}
                    style={{
                        maxWidth,
                        width: '100%',
                        borderRadius,
                        objectFit,
                        display: 'inline-block',
                    }}
                />
            </div>
        )
    },
}
